import { BaseModel } from './base.model';

export default class UserModel extends BaseModel {
  id: number|null;
  role: string|null;
  name: string|null;
  email: string|null;
  password: string|null;
  deletedAt: string|null = null;
  createdAt: string|null = null;
  updatedAt: string|null = null;
}
